import {useTranslation} from "react-i18next";

function TypeContent({register, required, errors}) {
  const { t } = useTranslation();

  return (
    <>
      <div className="c-write type">
        <div className="c-write_header">
          <span className="c-header_number">1</span>
          <p className="c-header_title">{t('Choisissez vote type de contenu')}</p>
        </div>
        <div className="c-write_content">
          <div className="c-content_card one">
            <div className="c-card_header">
              <span className="c-card_title">{t('News')}</span>
              <input type="radio" name="checkbox" value="news" {...register("type", { required : true})}/>
            </div>
            <p className="c-card_content">{t('text_editor_news')}</p>
          </div>
          <div className="c-content_card two">
            <div className="c-card_header">
              <span className="c-card_title">{t('Synthesis')}</span>
              <input type="radio" name="checkbox" value="synthesis" {...register("type", { required : true})}/>
            </div>
            <p className="c-card_content">{t('text_editor_synthese')}</p>
          </div>
          <div className="c-content_card three">
            <div className="c-card_header">
              <span className="c-card_title">{t('Memo')}</span>
              <input type="radio" name="checkbox" value="memo" {...register("type", { required : true})}/>
            </div>
            <p className="c-card_content">{t('text_editor_memo')}</p>
          </div>
        </div>
        {errors.type && <div className="c-errors">{t('Un type est obligatoire')}</div>}
      </div>
    </>
  )
}


export default TypeContent
